<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Free Setup Call'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (callScheduled) {
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <img src="assets/svg/checkmark-circle-outline.svg" class="onboarding-call-scheduled-icon" alt="" />
          <tidy-text [header]="'Call Scheduled'" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="'Your setup call is scheduled. Our concierge will walk you through how we manage your property.'" />
        </tidy-row>
      </tidy-card>
    } @else {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Our concierge will walk you through how we manage your property.'" />
      </tidy-row>

      <div
        #calendlyContainer
        class="calendly-inline-widget"
        data-url="https://calendly.com/thomaztidy/tidy-onboarding"
        style="min-width: 320px; height: 2000px; overflow: hidden;">
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
